import { Button, ButtonMode, ButtonSize } from '@creditsights/styleguide-web';
import classNames from 'classnames/bind';
import { ReactElement } from 'react';
import { NotificationMode } from '../../../models/User';
import styles from './AlertSettings.module.scss';

const cx = classNames.bind(styles);

const options = [NotificationMode.Digest, NotificationMode.Instant];

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function AlertSettings({ selected, onChange }): ReactElement {
  return (
    <div className={cx('body')}>
      <div className={cx('title')}>We’ll customize the content on your feeds and in email alerts based on your selections.</div>

      <div className={cx('selection')}>
        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
        <label>Email frequency:</label>
        <div className={cx('options')}>
          {options.map((option) => (
            <Button className={cx({ active: option === selected })} mode={ButtonMode.TERTIARY} size={ButtonSize.X_SMALL} onClick={() => onChange(option)} key={option}>
              {option}
            </Button>
          ))}
        </div>
      </div>
    </div>
  );
}

export default AlertSettings;
